import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Pagination from 'react-js-pagination';
import { formatNumber } from 'utils/currencyFormat';
import { getDate } from 'utils/formatDate';
import configs from "constants/configs";

let currentSlider = null;
const runSlider = () => {
  setTimeout(() => {
    // Init fancyBox
    window.$().fancybox({
      selector: '.slick-slide:not(.slick-cloned)',
      hash: false,
    });
    if (currentSlider) currentSlider.slick('unslick');
    currentSlider = window.$('#main-slider1').slick({
      slidesToShow: 7,
      slidesToScroll: 7,
      infinite: true,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
      ],
    });
    window.$('#main-slider1').resize();
  }, 100);
};
class ChiTietTaiSan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: '',
      dataSearch: {
        pageIndex: 1,
        pageSize: 20,
        taiSanId: 0,
      },
    };
  }
  componentDidMount() {
    let { taiSanId, getTaiSan, getLichSuTaiSan } = this.props;
    let { dataSearch } = this.state;
    getTaiSan({ taiSanId: taiSanId });
    dataSearch.taiSanId = taiSanId;
    getLichSuTaiSan(dataSearch);
    this.setState({ dataSearch });
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };
  handlePageChange = () => {
    let { dataSearch } = this.state;
    let { getLichSuTaiSan } = this.props;
    getLichSuTaiSan(dataSearch);
  };
  renderTableRows() {
    let { taisan } = this.props;
    let { List } = taisan.LichSuTaiSan;
    return List.map((item, index) => {
      let {
        TaiSanHistoryID,
        Time,
        Note,
        Type,
        Code,
        LyDo,
        UserCreate,
        Status,
        KhoXuat,
        KhoNhap,
        CustomerName,
        IndexId,
        Sotienvay,
      } = item;

      return (
        <tr className="active">
          <th scope="row">{IndexId}</th>
          <td>{getDate(Time)}</td>
          <td>{CustomerName}</td>
          <td>{formatNumber(Sotienvay)}</td>
          <td>{LyDo}</td>
          <td>{UserCreate}</td>
          <td>{Note}</td>
        </tr>
      );
    });
  }

  render() {
    let { onHide, show, taisan } = this.props;
    let { taiSan } = taisan;
    if (!taiSan || (taiSan && !taiSan.ThongTinTaiSan))
      taiSan = { ThongTinTaiSan: {}, AnhTaiSan: [] };
    let { TenTaiSan, StoreName, Status, Note, Code } = taiSan.ThongTinTaiSan;
    let { AnhTaiSan } = taiSan;

    // AnhTaiSan = AnhTaiSan.map(function (elem) {
    //   if (elem.Url.indexOf("Morman") > -1) {
    //     return configs.apiViewUpload + elem.Url;
    //   } if (elem.Url.indexOf("http") == -1) {
    //     return configs.imageServer + elem.Url;
    //   } else {
    //     return elem.Url;
    //   }
    // });
    let { dataSearch } = this.state;
    let { totalRow } = taisan.LichSuTaiSan;
    // if (AnhTaiSan.length > 0) {
    //   runSlider();
    // }

    return (
      <Modal
        show={show}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-clipboard-list-outline"></i>
            </span>{' '}
            Thông tin tài sản
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse253"
                  className="card-header border-info"
                  href="#collapse253"
                  aria-expanded="true"
                  aria-controls="collapse253"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Chi tiết tài sản</h3>
                  </a>
                </div>
                <div
                  id="collapse253"
                  aria-labelledby="headingCollapse253"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="main-slider slider-ts" id="main-slider1">
                        {AnhTaiSan.length > 0 && AnhTaiSan.map((item) => (
                          <a
                            href={
                              item.Url && item.Url.indexOf("http") > -1 ? item.Url
                                : item.Url.indexOf("/Upload/TaiSanImage/") > -1 ? configs.imageServer + item.Url
                                  : configs.apiViewUpload + item.Url
                            }
                            data-fancybox="images"
                          >
                            <img
                              src={
                                item.Url && item.Url.indexOf("http") > -1 ? item.Url
                                  : item.Url.indexOf("/Upload/TaiSanImage/") > -1 ? configs.imageServer + item.Url
                                    : configs.apiViewUpload + item.Url
                              }
                              width={180}
                            />
                          </a>
                        ))}
                      </div>
                      <div className="form-body form-bordered-1">
                        <div className="form-group row">
                          <label className="col-md-3 label-control">
                            Tên tài sản
                          </label>
                          <div className="col-md-9">{TenTaiSan}</div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-3 label-control">
                            Mã tài sản
                          </label>
                          <div className="col-md-9">{Code}</div>
                        </div>
                        {/* <div className="form-group row">
                          <label className="col-md-3 label-control">Kiểu</label>
                          <div className="col-md-9">Có giá trị</div>
                        </div> */}

                        <div className="form-group row">
                          <label className="col-md-3 label-control">Kho</label>
                          <div className="col-md-9">{StoreName}</div>
                        </div>

                        <div className="form-group row last-1">
                          <label className="col-md-3 label-control">
                            Ghi chú
                          </label>
                          <div className="col-md-9">{Note}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="headingCollapse25324"
                  className="card-header border-info mt-1"
                  href="#collapse25324"
                  aria-expanded="true"
                  aria-controls="collapse25324"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Lịch sử tài sản</h3>
                  </a>
                </div>
                <div
                  id="collapse25324"
                  aria-labelledby="headingCollapse25324"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="table-responsive table-2">
                        <table className="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>STT</th>
                              <th>Thời gian</th>
                              <th>Khách hàng</th>
                              <th>Số tiền</th>
                              <th>Lý do</th>
                              <th>Người tạo</th>
                              <th>Ghi chú</th>
                            </tr>
                          </thead>
                          <tbody>{this.renderTableRows()}</tbody>
                        </table>
                      </div>
                      <div
                        className={
                          'paniation-new paniation-new1 d-flex justify-content-center mt-1' +
                          (totalRow <= dataSearch.pageSize ? ' hidden' : '')
                        }
                      >
                        <nav aria-label="Page navigation">
                          <Pagination
                            activePage={dataSearch.pageIndex}
                            itemsCountPerPage={dataSearch.pageSize}
                            totalItemsCount={totalRow}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                            activeClass="active"
                          />
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ChiTietTaiSan;
